import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { authUserSelector } from '~redux/auth/selectors/authUser';

const MagBrandLink: React.FC<{
  brandId: string;
  className?: string;
  style?: React.CSSProperties;
}> = React.memo(({ brandId, className, style, children }) => {
  const auth = useSelector(authUserSelector);

  if (!auth) {
    return (
      <a
        className={className}
        href={`/mag/story/${brandId}`}
        style={style}
        translate="no"
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      className={className}
      to={`/brand/${brandId}${location.search}`}
      style={style}
      translate="no"
    >
      {children}
    </Link>
  );
});

export default MagBrandLink;
